require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-vote-mark-wiens-liberal.json") })
        }
      }, "path---projects-vote-mark-wiens-liberal");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projects-vote-mark-wiens-liberal!./.cache/json/projects-vote-mark-wiens-liberal.json
// module id = 536
// module chunks = 231608221292675